module.exports = __webpack_public_path__ + "img/settings.2c8b29cd.svg";